module.exports = __webpack_public_path__ + "img/common_top_logo.3613946b.png";